<template>
	<div>
		<a-modal :title="$t('common.upload')" :width="650" :visible="visible" @cancel="handleCancel()"
			:closable="false" :footer="null">
			
			<div>
				<a-form labelAlign="left" class="mt12" :label-col="{ span: 3 }">
					<a-form-model-item label="备注">
						<a-input placeholder="请输入备注" v-model="remark" style="width: 450px;" ></a-input>
					</a-form-model-item>
					<a-form-model-item label="文件链接">
						<a-input placeholder="请输入文件链接" v-model="remarkUrl" style="width: 450px;"></a-input>
					</a-form-model-item>
					<a-form-model-item label="上传文件">
						<upload-file @input="handleUplode" v-if="file==''">
							<div style="padding: 20px;border: 1px solid #EBEDF5;border-radius: 4px;">
								<a-icon type="plus" size="20"></a-icon>
							</div>
						</upload-file>
						<div class="flex alcenter" v-else>
							{{fileName}}
							
							<a-icon type="close" size="20" class="ml16" @click="clearFile()"></a-icon>
						</div>
					</a-form-model-item>
				</a-form>
			</div>
			
			<div class="mt-4 d-flex justify-content-center">
				<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()">
					{{ $t('recharge.cancel') }} </button>
				<button type="button" class="btn btn-theme ml16 px-4" @click="uploadAppendix()">
					{{ $t('common.upload') }} </button>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import uploadFile from "../../components/upload/upload_file.vue"
	export default{
		components:{
			uploadFile
		},
		props:{
			visible:{
				type: Boolean,
				default: false
			},
			order_id:{
				type:Number,
				default:0
			},
			status:{//1=笔记,2=作业,3=测验,学生不传1
				type:Number,
				default:2
			},
			is_teacher:{
				type: Boolean,
				default: false
			}
		},
		data() {
			return{
				file:'',
				fileName:'',
				remark:'',
				remarkUrl:''
			}
		},
		created() {
			
		},
		methods:{
			handleCancel(){
				this.$emit('cancel')
			},
			uploadAppendix(){
				if(this.is_teacher){
					this.$http.api('teacher/reservation/uploadAppendix',{
						order_id:this.order_id,
						status:this.status,//附录类型:1=笔记,2=作业,3=测验,学生不传1
						file:this.file,
						name:this.fileName,
						remark:this.remark,
						link:this.remarkUrl
					}).then(res=>{
						this.file = ''
						this.fileName = ''
						this.$message.success(this.$t('common.operationSuccessful'),1,()=>{
							this.$emit('ok')
						})
						
					})
				}else{
					this.$http.api('reservation/uploadAppendix',{
						order_id:this.order_id,
						status:this.status,//附录类型:1=笔记,2=作业,3=测验,学生不传1
						file:this.file,
						name:this.fileName,
						remark:this.remark,
						link:this.remarkUrl
					}).then(res=>{
						this.file = ''
						this.fileName = ''
						this.$message.success(this.$t('common.operationSuccessful'),1,()=>{
							this.$emit('ok')
						})
						
					})
				}
				
			},
			handleUplode(e){
				console.log("文件",e);
				this.file = e.file
				this.fileName = e.name
			},
			clearFile(){
				this.file = ''
				this.fileName = ''
			}
		}
	}
</script>

<style>
</style>